import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { Api } from '@/core/api';
import { getSurface, logout } from '@/core/auth';
import { formatAge } from '@/core/jalali';

const ROLE_FA: Record<string, string> = {
  guardian: 'سرپرست',
  self: 'خودم',
  practitioner: 'درمانگر',
  reporter: 'گزارش‌دهنده',
};

export function ProfilesPage() {
  const q = useQuery({ queryKey: ['profiles'], queryFn: Api.profiles });
  const surface = getSurface();
  return (
    <main className="page">
      <div className="row spread">
        <h1 className="page-title">پروفایل‌ها</h1>
        <button
          type="button"
          className="btn quiet"
          onClick={() => void logout().then(() => window.location.assign('/signin'))}
        >
          خروج
        </button>
      </div>
      {q.isLoading && <div className="skeleton" />}
      {q.data?.length === 0 && (
        <section className="card">
          <p>
            {surface === 'specialist'
              ? 'هنوز هیچ خانواده‌ای پروفایلی با شما به اشتراک نگذاشته است. کد اشتراکی که خانواده به شما داده را وارد کنید.'
              : 'هنوز پروفایلی ندارید. با چند سؤال ساده شروع کنید؛ هر وقت خواستید کامل‌ترش می‌کنید.'}
          </p>
        </section>
      )}
      {q.data?.map((p) => (
        <Link
          key={p.id}
          to="/p/$id"
          params={{ id: p.id }}
          className="card"
          style={{ color: 'inherit' }}
        >
          <div className="row spread">
            <strong style={{ fontSize: 'var(--fs-section)' }}>{p.displayName}</strong>
            <span className="chip">{ROLE_FA[p.myRole] ?? p.myRole}</span>
          </div>
          <div className="help">
            {formatAge(p.ageMonths)}
            {p.myBranches ? ` · ${p.myBranches.length} شاخه در دسترس شما` : ''}
          </div>
        </Link>
      ))}
      {surface !== 'specialist' && (
        <Link to="/new" className="btn primary block">
          + پروفایل تازه
        </Link>
      )}
      <Link to="/redeem" className="btn quiet block">
        کد اشتراک دارم
      </Link>
    </main>
  );
}
